var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.779,
    height: 26.37,
    viewBox: "0 0 21.779 26.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "walk",
    transform: "translate(-7.831 -2.724)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M23.016,28.918l-4.5-6.38-3.555-3.19a3.193,3.193,0,0,1-.8-2.065V10.1H15.4c1.76,0,3.188,1,3.188,2.239v10.2",
    transform: "translate(0.694 -1.392)",
    fill: "#666",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M8.956,18.39V14.245S11.9,10.1,14.858,10.1",
    transform: "translate(0 -1.392)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M26.631,19.24a1.944,1.944,0,0,1-.817-.174L21.023,16.9a1.159,1.159,0,0,1-.773-1V14.58a.32.32,0,0,1,.234-.278.617.617,0,0,1,.459.011l6.506,3.028a.907.907,0,0,1,.595,1.164,1.509,1.509,0,0,1-1.415.735Z",
    transform: "translate(1.504 -2.241)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M12.259,33.126a1.747,1.747,0,0,1-1.182-.415c-.49-.458-.318-.961.295-1.451l4.776-4.179a.791.791,0,0,1,.465-.075.632.632,0,0,1,.393.191c.125.142.27.316.414.509.417.557.478.9-.134,1.438-.638.56-4.143,3.774-4.143,3.774a1.512,1.512,0,0,1-.884.207Z",
    transform: "translate(0.245 -4.84)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M21.369,4.359c0,1.145-1.322,2.073-2.952,2.073S15.466,5.5,15.466,4.359s1.321-2.073,2.951-2.073S21.369,3.215,21.369,4.359Z",
    transform: "translate(-0.268 1)",
    fill: "#666",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.125
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkIcon);
export default __webpack_public_path__ + "static/media/walk-icon.4c479ac04d18560281660ebd42622722.svg";
export { ForwardRef as ReactComponent };